import { render, staticRenderFns } from "./FinalizacaoEnviarParaAprovacao.vue?vue&type=template&id=36ef4a61"
import script from "./FinalizacaoEnviarParaAprovacao.vue?vue&type=script&lang=js"
export * from "./FinalizacaoEnviarParaAprovacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports